// import Vue from 'vue'
import { Model } from '@vuex-orm/core'

// import Composition from './composition.model'

export default class CompositionOrder extends Model {
  static entity = 'compositionsOrders'

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(''),
      data: this.attr({}),
      quantity: this.attr(1),
      price: this.attr(),
      isAdition: this.attr(false),
    }
  }
}
